<nav>
  @if (backButton()) {
    <button class="button button-link button--dark button--xs" (click)="goBack()">
      <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
      <span>Terug</span>
    </button>
  }

  @if (!backButton()) {
    <h2 class="sr-only">Kruimelpad</h2>

    <ul>
      @for (crumb of breadcrumbs(); track $index) {
        <li>
          <a class="link-reset text-decoration-underline" [routerLink]="crumb.routerLink">
            {{ crumb.text }}
          </a>
        </li>
      }
    </ul>
  }
</nav>
